import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// List of all locale prefixes that have static SEO pages
const LOCALE_PREFIXES = [
  'ar-ae', 'ar-iq', 'de-de', 'en', 'en-ae', 'en-bh', 'en-br', 'en-eg', 
  'en-et', 'en-gb', 'en-gh', 'en-il', 'en-in', 'en-iq', 'en-ke', 'en-kw', 
  'en-lk', 'en-ma', 'en-ng', 'en-om', 'en-pk', 'en-qa', 'en-sa', 'en-sg', 
  'en-tr', 'en-tz', 'en-ug', 'en-us', 'en-za', 'es-es', 'es-us', 'fr-fr', 
  'he-il', 'hi-in', 'it-it', 'ja-jp', 'ko-kr', 'nl-nl', 'pl-pl', 'pt-pt', 
  'ro-ro', 'ru-il', 'si-lk', 'sv-se', 'ta-lk', 'tr-tr', 'ur-pk', 'zh-cn'
];

/**
 * StaticPageHandler - Detects when a user navigates to a static SEO page URL
 * and forces a full page load to serve the static HTML instead of React SPA
 */
export default function StaticPageHandler() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Check if this path matches a static SEO page pattern
    // Pattern: /{locale}/wholesale/... or /{locale}/...
    const pathParts = path.split('/').filter(Boolean);
    
    if (pathParts.length >= 1) {
      const potentialLocale = pathParts[0];
      
      // If the first part of the path is a known locale prefix
      if (LOCALE_PREFIXES.includes(potentialLocale)) {
        // This is a static SEO page - force full page reload to get static HTML
        // Using window.location.href ensures the server serves the static file
        // instead of React Router intercepting the navigation
        
        // Add index.html to ensure we hit the static file
        let targetUrl = path;
        if (!path.endsWith('/') && !path.endsWith('.html')) {
          targetUrl = path + '/';
        }
        
        // Only reload if we're not already showing static content
        // Check if current document is React app (has root div with React content)
        const isReactApp = document.getElementById('root')?.children?.length > 0;
        
        if (isReactApp) {
          // Force browser to load the static HTML file directly
          window.location.replace(targetUrl);
        }
      }
    }
  }, [location.pathname]);
  
  return null;
}

/**
 * Check if a given path is a static SEO page
 */
export function isStaticSeoPath(path) {
  const pathParts = path.split('/').filter(Boolean);
  if (pathParts.length >= 1) {
    return LOCALE_PREFIXES.includes(pathParts[0]);
  }
  return false;
}
